var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPortInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.44401 1.77718C4.49849 1.77718 2.11068 4.165 2.11068 7.11051C2.11068 10.056 4.49849 12.4438 7.44401 12.4438C10.3895 12.4438 12.7773 10.056 12.7773 7.11051C12.7773 4.165 10.3895 1.77718 7.44401 1.77718ZM0.777344 7.11051C0.777344 3.42862 3.76211 0.443848 7.44401 0.443848C11.1259 0.443848 14.1107 3.42862 14.1107 7.11051C14.1107 10.7924 11.1259 13.7772 7.44401 13.7772C3.76211 13.7772 0.777344 10.7924 0.777344 7.11051ZM7.44401 3.11051C7.8122 3.11051 8.11068 3.40899 8.11068 3.77718V6.83437L9.24875 7.97244C9.5091 8.23279 9.5091 8.6549 9.24875 8.91525C8.9884 9.1756 8.56629 9.1756 8.30594 8.91525L6.97261 7.58192C6.84758 7.45689 6.77734 7.28733 6.77734 7.11051V3.77718C6.77734 3.40899 7.07582 3.11051 7.44401 3.11051Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortInfo);
export default __webpack_public_path__ + "static/media/PortInfo.2de72d833ba477be97e9ef532dd8d60e.svg";
export { ForwardRef as ReactComponent };